export const CATEGORY_TEMPLATE = `
    <div class="bw-tours bw-clear bw-tour-category-[tour_category_id]">
        <h2 class="bw-tours__category-header">
            <a class="bw-tours__category-link" href="[tour_category_url]"><img class="" height="40" width="40" src="[tour_category_icon]">[tour_category_name]</a>
        </h2>
        <div class="bw-tours__list"></div>
    </div>
`;

export const CARD_TEMPLATE = `
    <div class="bw-tours__card [booking_status_class]" data-tour-id="[tour_id]">
        <div class="bw-tours__card__content">
            <a href="#" class="bw-tours__card__img" data-image="[tour_image_url]" style="background:#ccc"></a>
            <div class="bw-tours__card__bottom">
                <div class="bw-tours__card__details">
                    <h3 class="bw-tours__card__title">[tour_name]</h3>
                    <p>
                        <span class="bw__icomoon bw__icomoon--clock"></span> [tour_duration] hrs</span> 
                        <span class="bw-tours__card__details--price">Adult $[adult_price]</span>
                        <span class="bw-tours__card__details--price">Child $[child_price]</span>
                    </p>
                    <a href="#" class="bw-tours__detail-link bw-tours__card__link" data-tour-id="[tour_id]">Details</a>
                </div>
                <div class="bw-tours__card__action">
                    <a href="#" class="bw-tours__button bw-tours__button--book" data-tour-id="[tour_id]"><span class="bw__icomoon bw__icomoon--cart bw-desktop-icon"></span>BOOK NOW</a>
                    <span class="bw-tours__button bw-tours__button--sold-out"><span class="bw__icomoon bw__icomoon--no-sign bw-desktop-icon"></span>Unavailable</span>

                    <a href="tel:8083356833" class="bw-tours__button bw-tours__button--cutoff">
                        <div>
                            <span>
                                <span class="bw__icomoon bw__icomoon--phone bw-desktop-icon"></span>CALL US<br>
                                <span class="f12">808-335-6833</span>
                            </span>
                        </div>
                    </a>
                    <a href="#" class="bw-tours__waitlist-link bw-tours__card__link" data-ts-modal-open="bw-waitlist-modal" data-capacity="[capacity]" data-tour-id="[tour_id]">Add Me to the Waitlist</a>
                </div>
            </div>
        </div>
    </div>
`;

export const FOOTER_TEMPLATE = `
    <div class="bw__copyright">&copy; 1980 - ${(new Date()).getFullYear()}</div>
    <div class="bw__powered-by"><span class="bw__powered-by__text">Powered By</span><img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" data-src="${URL_ROOT}public-api/${BOOKING_VERSION}/images/logo.png" width="71" height="40" alt="Captain Andy logo" class="bw__powered-by__image"></div>
`;

export const MODAL_TEMPLATE = `
    <section class="bw-modal" id="[modal_id]" aria-hidden="true">
        <div class="bw-modal__overlay" tabindex="-1" data-ts-modal-close>
            <div class="bw-modal__container" role="dialog" aria-modal="true">
                <a class="bw-modal__close" href="#" title="close" aria-label="Close modal"><span class="bw__icomoon bw__icomoon--clear" data-ts-modal-close></span></a>
                <main class="bw-modal__content"></main>
                <footer class="bw-modal__footer">${FOOTER_TEMPLATE}</footer>
            </div>
        </div>
    </section>
`;

export const PICKERS_TEMPLATE = `
    <div class="bw">
        <div class="bw-pickers">
            <button class="bw-pickers__picker bw-pickers__picker--datepicker bw-pickers__button" data-touched="0">
                <span class="bw-pickers__picker-icon bw__icomoon bw__icomoon--calendar"></span>
                <span class="bw-pickers__picker-text bw-pickers__datepicker-display"></span>
                <span class="bw-pickers__picker-toggle bw__icomoon bw__icomoon--expand_more"></span>
            </button>
            <div class="bw-pickers__picker bw-pickers__picker--timepicker">
                <span class="bw-pickers__picker-icon bw__icomoon bw__icomoon--clock"></span>
                <div class="bw__select-wrap">
                    <select class="bw-pickers__timepicker-control" name="booking_timeofday">
                        <option value="" selected>Anytime</option>
                        <option value="morning">Morning</option>
                        <option value="afternoon">Afternoon</option>
                    </select>
                </div>
            </div>
            <button class="bw-pickers__picker bw-pickers__picker--guestpicker bw-pickers__button" data-guests-adult="2" data-guests-child="0" data-guests-toddler="0" data-touched="0">
                <span class="bw-pickers__picker-icon bw__icomoon bw__icomoon--group"></span>
                <span class="bw-pickers__picker-text bw-pickers__guestpicker-display">2 Adult</span>
                <span class="bw-pickers__picker-toggle  bw__icomoon bw__icomoon--expand_more"></span>
            </button>
            <button class="bw-pickers__btn-submit bw-pickers__button"><span class="bw__icomoon bw__icomoon--search"></span></button>
        </div>
        <div class="bw__results"></div>
    </div>
`;

export const TOUR_SPECIFIC_MODAL_TEMPLATE = `
    <div class="bw-modal" id="[modal_id]" aria-hidden="true">
        <div class="bw-modal__overlay" tabindex="-1" data-ts-modal-close>
            <div class="bw-modal__container" role="dialog" aria-modal="true">
                <a class="bw-modal__close" href="#" title="close" aria-label="Close modal"><span class="bw__icomoon bw__icomoon--clear" data-ts-modal-close></span></a>
                <main class="bw-modal__content">
                    <div class="btvp">
                        <div class="btvp__tour-description bw-ca"></div>
                        <div class="btvp__tour-booking">
                            <h2 class="btvp__header"></h2>
                            <div class="btvp__booking-picker"></div>
                            <div class="btvp__footer">
                                <div class="btvp__footer__line bw-light-gray" style="text-align:center;">*Check-in <span class="btvp__checkin"></span> minutes prior to departure</div>
                                <a href="#" class="btvp__footer__line btvp__gift bw-link bw-gift-tour"><span class="bw__icomoon bw__icomoon--gift"></span> Purchase a gift certificate</a>
                            </div>
                        </div>
                    </div>
                </main>
                <footer class="bw-modal__footer">${FOOTER_TEMPLATE}</footer>
            </div>
        </div>
    </div>
`;
export const TOUR_SPECIFIC_CARD_TEMPLATE = `
    <div class="bw-tours__row [booking_status_class]">
        <div class="bw-tours__row__content">
            <div class="bw-tours__row__left">
                <div class="bw-tours__row__details--date">[day_month_date]</div>
                <div class="bw-tours__row__details--time">[start_time] - [end_time]</div>
            </div>
            <div class="bw-tours__row__right">
                <div class="bw-tours__row__details--price"><span class="bw-dark-blue">$[adult_price]</span> per adult, <span class="bw-dark-blue">$[child_price]</span> per child</div>
                <a href="#" class="bw-tours__button bw-tours__button--book" data-tour-vessel-id="[tour_vessel_id]">BOOK</a>
                <a href="tel:808-335-6833" class="bw-tours__button bw-tours__button--cutoff" title="Call us at 808-335-6833">CALL US!</a>
                <a href="#" class="bw-tours__waitlist-link bw-tours__row__link hide" data-ts-modal-open="bw-waitlist-modal" data-capacity="[capacity]" data-tour-id="[tour_id]">Add Me to the Waitlist</a>
            </div>
        </div>
    </div>
`;

export const PAGE_ERROR = `
<div class="bw-ca">
    <div class="container w960">
        <div class="grid-wrap">
            <div class="grid-col bp2-col-two-thirds">
                <div class="cart island pad-b0">
                    <h1 class="pad-b16">[error_title]</h1>
                    <p class="pad-b0">[error_message]</p>
                </div>
            </div>
        </div>
    </div>
</div>
`;

export const PASSENGER_ROW = `
<div class="passenger-row grid-wrap">
    <input type="hidden" name="is_child" value="[is_child]">
    <p class="grid-col col-one-half pad-r8">
        <label for="first-name-[idx]" class="screen-reader-text">[is_child_label] First Name</label>
        <input
            placeholder="[is_child_label] First Name[required_asterisk]"
            type="text"
            id="first-name-[idx]"
            data-contact-idx="[idx]"
            name="first_name"
            value=""
            [first_name_atts]
        />
        <span class="hide warning f12 block" style="padding: 4px 2px;"></span>
    </p>
    <p class="grid-col col-one-half">
        <label for="last-name-[idx]" class="screen-reader-text">[is_child_label] Last Name</label>
        <input
            placeholder="[is_child_label] Last Name[required_asterisk]"
            type="text"
            id="last-name-[idx]"
            data-contact-idx="[idx]"
            name="last_name"
            value=""
            [last_name_atts]
        />
        <span class="hide warning f12 block" style="padding: 4px 2px;"></span>
    </p>
    <p class="food-preference-row">
        <span>[food_pref_intro]</span>
        [food_preferences]
    </p>
</div>
`;

export const FOOD_PREFERENCE = `
    <label for="food_preference-[idx]-[food_pref_key]" class="mar-r16"><input type="checkbox" id="food_preference-[idx]-[food_pref_key]" name="food_preference" value="[food_pref_value]" data-contact-idx="[idx]" class="mar-l0" /> <span>[food_pref_value]</span></label><a href="#" data-ts-modal-open="[food_pref_modal_id]" class="food-menu-link [hide_show_class]">?</a>
`;

export const PAYMENT_PAGE_CONTACT_CC = `
<div class="island border-b">
    <h3>Contact</h3>
    <p class="f16 c54">* Required Fields</p>
    <!-- email -->
    <p>
        <label for="email" class="screen-reader-text">Email*</label>
        <input
            placeholder="Email*"
            type="email"
            id="email"
            name="email"
            value=""
            required
        />
    </p>
    <!-- confirm_email -->
    <p>
        <label for="confirm_email" class="screen-reader-text">Confirm Email*</label>
        <input
            placeholder="Confirm Email*"
            type="email"
            id="confirm_email"
            name="confirm_email"
            value=""
            required
        />
        <span class="warning f12 block" id="email-warning" style="padding: 4px 2px;" data-target="email-warning"></span>
    </p>
    <!-- phone -->
    <p>
        <label for="phone" class="screen-reader-text">Phone*</label>
        <input
            placeholder="Phone*"
            type="tel"
            id="phone"
            name="phone"
            value=""
            pattern="^[0-9-\s()+]*$"
            required
        />
    </p>
    <p>
        <label for="confirm-phone" class="screen-reader-text">Confirm Phone*</label>
        <input
            placeholder="Confirm Phone* "
            type="tel"
            id="confirm_phone"
            name="confirm_phone"
            value=""
            pattern="^[0-9-\s()+]*$"
            required
        />
        <span class="warning f12 block" id="phone-warning" style="padding: 4px 2px;" data-target="phone-warning"></span>
        <span><label class="show" for="opt-in-sms"><input type="checkbox" id="opt-in-sms" checked />I agree to opt-in and receive messages and updates about my reservation. Standard text message rates apply. Reply STOP to opt out.</label></span>
    </p>
    <p>
    </p>
</div>
<div class="island border-b">
    <!-- payment info -->
    <h3>Credit Card</h3>
    <p class="f16 c54">* Required Fields</p>
    <div class="error cc-error mar-b16" style="display: none;"></div>
    <p class="grid-col col-one-half pad-r8">
        <label class="screen-reader-text" for="cc-first-name">First Name*</label>
        <input placeholder="First Name*" type="text" id="cc-first-name" name="cc_first_name" value="" required=""> 
    </p>
    <p class="grid-col col-one-half">
        <label class="screen-reader-text" for="cc-last-name">Last Name*</label>
        <input placeholder="Last Name*" type="text" id="cc-last-name" name="cc_last_name" value="" required=""> 
    </p>
    <input type="hidden" id="cardholder_name" name="cc_cardholder_name">
    <!-- cc number -->
    <p>
        <label for="cc_number" class="screen-reader-text">Credit Card Number*</label>
        <input
            placeholder="•••• •••• •••• ••••"
            type="text"
            id="cc_number"
            name="cc_number"
            autocomplete="cc-number"
            value=""
            required
        />
    </p>
    <!-- cc expiration date -->    
    <p class="grid-col col-one-half pad-r8">
        <select id="exp_month" name="cc_exp_month" required>
            <option value="">Month*</option>
            <option value="01" >01 - January</option>
            <option value="02" >02 - February</option>
            <option value="03" >03 - March</option>
            <option value="04" >04 - April</option>
            <option value="05" >05 - May</option>
            <option value="06" >06 - June</option>
            <option value="07" >07 - July</option>
            <option value="08" >08 - August</option>
            <option value="09" >09 - September</option>
            <option value="10" >10 - October</option>
            <option value="11" >11 - November</option>
            <option value="12" >12 - December</option>
        </select>
        </p>
        <p class="grid-col col-one-half">
        <select id="exp_year" name="cc_exp_year" required>
            <option value="">Year*</option>
        </select>
        </p>
    <!-- ccv -->
    <p>
        <label for="cvv_code" class="screen-reader-text">CVV*</label>
        <input
            placeholder="CVV*"
            type="text"
            id="cvv_code"
            name="cc_cvv"
            maxlength="4"
            value=""
            required
        />
    </p>
    <!-- zip -->
    <p>
        <label for="zip" class="screen-reader-text">Zip Code*</label>
        <input
        placeholder="Zip Code*"
        type="text"
        id="zip"
        name="cc_zip"
        value=""
        required
        />
    </p>
    <!-- End: #payment-info -->    
</div>
`;

export const PAYMENT_PAGE_CART = `
<table class="border-b">
    <tbody>
        <tr>
            <td>Subtotal</td>
            <td class="tright">$<span data-target="subtotal">[subtotal]</span></td>
        </tr>
    </tbody>
</table>
<table class="pad-b0">
    <tbody>
        <tr class="cart-tax-row">
            <td>Tax/Fees</td>
            <td class="tright">$<span data-target="taxes-fees">[taxes_fees]</span></td>
        </tr>
        <tr class="cart-gc-row" style="display: none;">
            <td>Gift Certificate</td>
            <td class="tright">-$<span data-target="gift-code-amount">0</span></td>
        </tr>
        <tr>
            <td><strong>Total</strong> </td>
            <td class="tright"><strong>$<span data-target="total-price">[total_price]</span></strong></td>
        </tr> 
    </tbody>
</table>`;

export const PAYMENT_PAGE_GC = `
<div class="bw-ca">
    <div class="bg-white">
        <div class="container w960">
            <div class="grid-wrap">
                <div class="grid-col">
                    <div class="cart island pad-b0">
                        <h1 class="pad-b16">Gift Certificate</h1>
                        <p class="pad-b4">Gift certificates are valid for 5 years from date of purchase and may be used for any tours we offer.</p>
                    </div>
                </div>
                <div class="grid-col col-full">
                    <div class="cart island pad-t0">`

                        + PAYMENT_PAGE_CART + 

                        `<div class="f16 c54 pad-t16 center"><span class="tablet">You're booking direct with Capt Andy's – </span><strong>Best Price Guaranteed</strong></div>        
                    </div>
                </div>
            </div>
        </div>
    </div>

    <form action="https://www.napali.com/book/terms/" method="post" name="info" id="info">
        <a name="reservation"></a>
        <div class="container w960 pad-b32">
            <div id="order" class="grid-wrap">
                <div class="grid-col col-full">`

                    + PAYMENT_PAGE_CONTACT_CC +

                `</div>
            </div>
        </div>

        <div class="container w960 pad-b32">
            <div id="order" class="grid-wrap">
                <div class="grid-col col-full">
                    <div class="islandb">
                        <button id="submit-info" data-original="COMPLETE BOOKING" type="submit" class="btn">COMPLETE BOOKING
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <input type="hidden" name="reservation_id" value="">
        <input type="hidden" name="payment_amount" data-target="payment-amount" value="[total_price]">
        <input type="hidden" name="payment_method" value="cc">
        <input type="hidden" name="passenger_id" value="">
        <input type="hidden" name="contact_id" value="">
    </form>
</div>
`;
export const PAYMENT_PAGE_TOUR = `
<div class="bw-ca">
    <div class="bg-white">
        <div class="container w960">
            <div class="grid-wrap">
                <div class="grid-col bp2-col-two-thirds">
                    <div class="cart island pad-b0">
                        <h1 class="pad-b16">[tour_name]</h1>
                        <p class="pad-b4">Departs [tour_departs]</p>
                        <p class="f16 c54">Check-in [checkin_minutes] min prior to departure.</p>
                    </div>
                </div>
                <div class="grid-col bp2-col-one-third">
                    <div class="cart island c54 f16 tright pad-b0">
                        <a class="gift-code-label c54"><span class="underline">Gift Certificate</span></a>
                        <span class=""> or </span>
                        <a class="promo-code-label c54"><span class="underline">Promo Code</span>?</a>

                        <form action="" method="post" name="gift-form" class="gift-form il">
                            <div class="gift-code-container" style="display: none">
                                <input name="giftCode" type="text" value="" placeholder="Gift Certificate" class="w150 il">
                                <button class="btn-sm">APPLY</button>
                            </div>
                            <div class="error gift-code-error"></div>
                        </form>
                        <div class="gift-code-verified" style="display: none;">
                        <a href="#" class="gift-remove-button"><span class="bw__icomoon bw__icomoon--clear" title="remove gift code"></span></a> Gift Code Verified: <span data-target="gift-code"></span>
                        </div>
                        <form action="" method="post" name="promo-form" class="promo-form il">
                            <div class="promo-code-container" style="display: none">
                                <input name="promoCode" type="text" value="" placeholder="Promo Code" class="w150 il">
                                <input type="hidden" name="trip_id" value="[trip_id]">
                                <button class="btn-sm">APPLY</button>
                            </div>
                            <div class="warning promo-code-error"></div>
                        </form>
                        <div class="promo-code-verified" style="display: none;">
                        <a href="#" class="promo-remove-button"><span class="bw__icomoon bw__icomoon--clear" title="remove promo code"></span></a> Promo Code Verified: <span data-target="promo-code"></span>
                        </div>
                    </div>
                </div>
                <div class="grid-col col-full">
                    <div class="cart island pad-t0">
                        <table class="border-b">
                            <tbody>
                                <tr>
                                    <td>[adult_count] @ $[adult_price_base]</td>
                                    <td class="tright">$[adult_price_total]</td>
                                </tr>
                                <tr class="cart-child-row">
                                    <td>[child_count] @ $[child_price_base]</td>
                                    <td class="tright">$[child_price_total]</td>
                                </tr>
                                <tr class="cart-discount-row" style="display: none;">
                                    <td>You Save</td>
                                    <td class="tright">-$<span data-target="discount">0</span></td>
                                </tr>
                            </tbody>
                        </table>`

                        + PAYMENT_PAGE_CART + 

                        `<div class="f16 c54 pad-t16 center"><span class="tablet">You're booking direct with Capt Andy's – </span><strong>Best Price Guaranteed</strong></div>        
                    </div>
                </div>
            </div>
        </div>
    </div>

    <form action="https://www.napali.com/book/terms/" method="post" name="info" id="info">
        <a name="reservation"></a>
        <div class="container w960 pad-b32">
            <div id="order" class="grid-wrap">
                <div class="grid-col col-full">
                    <div class="island border-b">
                        <h1 class="pad-b16">Make a Reservation</h1>
                        <p class="pad-b0">Seats run out quickly. We recommend making your reservation at least 6 weeks prior to your vacation.</p>
                        <div class="error reservation-error mar-t16" style="display:none;"></div>
                    </div>`

                    + PAYMENT_PAGE_CONTACT_CC +

                    `<div class="island border-b">
                        <!-- Kauai info -->
                        <h3>Kauai Info</h3>
                        <p class="f16 c54">In case we need to get in touch (e.g. weather).</p>
                        <p style="display:none" id="kauai-info">
                            <label class="screen-reader-text">Arrival date</label>
                            <input type="text"
                                id="datepicker2"
                                placeholder="Arrival Date"
                                name="arrivalDate"
                                maxlength="10"
                                value=""
                            />
                        </p>
                            <p>
                            <label for="hotel" class="screen-reader-text">Hotel</label>
                            <input type="text" name="hotel_id" 
                                data-autocomplete-field="hotel_id" 
                                data-autocomplete-key="hotel" 
                                data-target="hotel-id"
                                style="display:none"
                            />
                            <input aria-label="Hotel" type="text" name="hotel" class="autocomplete"
                                data-autocomplete-key="hotel"
                                data-autocomplete-field="name"
                                data-target="hotel-name"
                                placeholder="Hotel" 
                                autocomplete="off"
                            />
                        </p>
                    </div><!-- End: #kauai-info -->
                    
                    <div class="island border-b passenger-names">
                        <h3 class="pad-b16">Passenger Names</h3>
                        <div class="error pax-error mar-b16" style="display: none;"></div>
                        <p class="f16 c54">* Required Fields</p>
                        <!-- PASSENGER_ROW -->
                    </div>
                    <!-- by D added disable input -->
                    <div class="island">
                        <h3 class="pad-b16">
                            Traveling with another party or group?
                            <span> <label class="show" for="disable-group-name"><input type="checkbox" id="disable-group-name"  /> Yes</label></span>
                        </h3>
                        <p class="f16 c54">
                        This tour is offered on multiple vessels. Please let us know if you are traveling with someone who made a separate reservation. We’ll be sure to get you on the same boat! If you don't know your party's or group's name, email fun@napali.com or call 808-335-6833 at least 24 hours prior to departure.</p>
                        <p>
                            <label for="groupName">Group's Name</label>
                                <input
                                    placeholder="Group's Name"
                                    type="text"
                                    name="reservation_group_name"
                                    value=""
                                    disabled />
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="bg-white">
            <div class="container w960">
                <div class="grid-wrap">
                    <div class="grid-col col-full">
                        <div class="terms-conditions island">
                            <h1 class="pad-t16">Terms &amp; Conditions</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container w960 pad-b32">
            <div id="order" class="grid-wrap">
                <div class="grid-col col-full">
                    <div class="islandb">
                        <button id="submit-info" data-original="COMPLETE BOOKING" type="submit" class="btn">COMPLETE BOOKING
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <input type="hidden" name="reservation_id" value="">
        <input type="hidden" name="gift_certificate_id" value="">
        <input type="hidden" name="tour_vessel_id" value="[trip_id]">
        <input type="hidden" name="promo_code_id" data-target="promo-code-id" value="">
        <input type="hidden" name="opt_in" value="1">

        <input type="hidden" name="payment_amount" data-target="payment-amount" value="[total_price]">
        <input type="hidden" name="payment_method" value="cc">
    </form>

    <div class="food-preference-popup-container" style="display: none"></div>
</div>
</div>
`;

export const COMPLETE_PAGE_GC = `
<div class="container w960"><div class="grid-wrap">
<div class="grid-col col-full">
    <div class="island">
        <h1 class="green pad-16 mar-b16"><span class="bw__icomoon bw__icomoon--check f32"></span> &nbsp;Gift Certificate Purchased</h1>
        <div class="pad-16 bg-blue">
            <h2 class="white">Gift Code*: [[gc_code]]</h2>
            <p class="pad-b4 white">Expires: [[expires]]</p>
        </div>
        <p class="f14 c54 pad-t16 pad-b16">*The Gift Code is used to redeem this gift certificate when making a reservation online or by phone.</p>
        <h4 class="pad-t16 pad-b8">Gift Certificate Details</h4>
        <p class="pad-b4">Value: $[[gc_value]]</p>
        <p class="pad-b4">Purchased by: [[purchaser_name]] </p>
        <p class="pad-b4">[[payment_info]]</p>
    </div>
</div>
</div></div>
`;

export const COMPLETE_PAGE_TOUR = `<div class="container w960"><div class="grid-wrap">
<div class="grid-col col-full">
    <div class="island">
        <h1 class="green">Reservation Complete <span class="bw__icomoon bw__icomoon--check f32" style="vertical-align:baseline;"></span></h1>
    </div>
</div>
<div class="grid-col col-full">
    <div class="island">
        <h3>Welcome Aboard!</h3>
        <p class="pad-b16">Please watch this short briefing video prior to your tour.</p>
        <div class="video-container">
            <iframe width="560" height="315" src="[[tour_video_url]]" title="Short briefing video" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
    </div>
</div>
<div class="grid-col col-full">
    <div class="island">
        <h3 class="pad-b16">Tour Details</h3> 
        <p>
            [[tour_name]]<br>
            Departs [[tour_start_date]]<br>
            <span class="pad-b4 green">Check-in [[tour_checkin_minutes]] min prior to departure at [[checkin_location]].</span><br>
            [[payment_info]]<br>
            <strong>Reservation #[[reservation_number]]</strong><br>
            [[passenger_summary]]<br>
        </p>
        <p>You should receive a confirmation email within 10 minutes to [[email]]</p>
        <p class="pad-b0">If you need to make changes to your reservation, please call <a href="tel:1-808-335-6833">(808) 335-6833</a> or email <a href="mailto:fun@napali.com">fun@napali.com</a>.</p>
    </div>
</div>
<div class="grid-col col-full">
    <div class="island">
        <h3 class="pad-b16">Just a few things to help you be better prepared!</h3>
        [[tour_res_complete_partial]]
    </div>
</div>
</div></div>`;

export const EMAIL_THIS_PAGE = `
<div class="bg-white">
    <div class="container w960">
        <div class="grid-wrap">
            <div class="grid-col bp-col-two-thirds">
                <div class="island">
                    <form name="email-form" class="bw-email-form">
                        <input type="text" name="emails" value="" placeholder="one@email.com,two@email.com,..." required>
                        <button type="submit" class="btn-sm bw-email-form__button">Email This Page</button>
                    </form>
                    <div class="bw-email-form-message"></div>
                </div>
            </div>
        </div>
    </div>
</div>
`;

export const WAITLIST_TEMPLATE = `
    <div class="bw-waitlist bw-ca">
        <h1 class="mar-b16">Add Me to the Waitlist</h1>
        <div class="error waitlist-error mar-b16" style="display:none;"></div>
        <form name="waitlist-form">
            <input type="hidden" name="tour_id" value="">
            <label class="screen-reader-text">First Name</label>
            <input type="text" name="first_name" placeholder="First Name" class="mar-b8" required>

            <label class="screen-reader-text">Last Name</label>
            <input type="text" name="last_name" placeholder="Last Name" class="mar-b8" required>

            <label class="screen-reader-text">Phone Number</label>
            <input type="text" name="phone" placeholder="Phone Number" class="mar-b8" required>

            <label class="screen-reader-text">Email</label>
            <input type="text" name="email" placeholder="Email" class="mar-b8" required>

            <label class="screen-reader-text">Waitlist Start/End Dates</label>
            <input type="text" name="start_end" placeholder="Waitlist Start/End Dates" class="bw-waitlist__datepicker mar-b8" required>
            <input type="hidden" name="start_date" value="">
            <input type="hidden" name="end_date" value="">
            <div class="error date-error mar-b16" style="display:none;"></div>

            <div class="bw-waitlist__counts mar-b16">
                <div class="bw-waitlist__count">
                    <input type="text" id="bw-waitlist-adult" name="adult" value="1" class="input--number" required>
                    <label for="bw-waitlist-adult">
                        <div class="bw-waitlist__counts__controls">
                            <span class="bw__icomoon bw__icomoon--ca_up"></span>
                            <span class="bw__icomoon bw__icomoon--ca_down"></span>
                        </div>Adults
                    </label>
                </div>
                <div class="bw-waitlist__count">
                    <input type="text" id="bw-waitlist-child" name="child" value="0" class="input--number">
                    <label for="bw-waitlist-child">
                        <div class="bw-waitlist__counts__controls">
                            <span class="bw__icomoon bw__icomoon--ca_up"></span>
                            <span class="bw__icomoon bw__icomoon--ca_down"></span>
                        </div>Children
                    </label>
                </div>
                <div class="bw-waitlist__count">
                    <input type="text" id="bw-waitlist-toddler" name="toddler" value="0"  class="input--number">
                    <label for="bw-waitlist-toddler">
                        <div class="bw-waitlist__counts__controls">
                            <span class="bw__icomoon bw__icomoon--ca_up"></span>
                            <span class="bw__icomoon bw__icomoon--ca_down"></span>
                        </div>Toddlers
                    </label>
                </div>
            </div>

            <div class="bw-waitlist__count-details bw-gray mar-b16">
                Adults [adult_ages]<br>
                Children [child_ages]<br>
                <span class="toddlers-line">Toddlers [toddler_ages]<br></span>
                <br>
                <span class="exclusions"></span>
            </div>
            <div class="bw-waitlist__terms mar-b16">
                <input type="checkbox" id="bw-waitlist__terms-checkbox" name="tc_agree" value="1" required>
                <label for="bw-waitlist__terms-checkbox">By checking this box, I understand that the selected tour is full and I do not have a confirmed reservation.  I agree to be placed on the waitlist and agree to be contacted if seats become available.</label>
            </div>

            <button class="bw-tours__button" type="submit">ADD TO WAITLIST</button>
            <div class="success--waitlist bg-green white pad-8">Mahalo.  We will contact you if space becomes available.</div>
        </form>
    </div>
`;